import React from "react";
import { info } from "@randajan/simple-app/fe";
import jet from "@randajan/jet-core";

import { LandingPage } from "./LandingPage/LandingPage";
import { ServicePage } from "./ServicePage/ServicePage";
import { createRouter } from "@randajan/jet-react/dom/router";
import { serviceAreas } from "../content";
import { contactLink } from "../frames/Contact/ContactProvider";

import page from "@randajan/jet-react/base/page";
import tab from "@randajan/jet-react/base/tab";

const serviceById = Object.fromEntries(serviceAreas.map(service => [service.id, service]));

export const navigationItems = [
  { title:"O nás", to:"/" },
  { title:serviceById.logistics.menuTitle, to:serviceById.logistics.route },
  { title:serviceById["it-nis2"].menuTitle, to:serviceById["it-nis2"].route },
  { title:serviceById.telecommunications.menuTitle, to:serviceById.telecommunications.route },
  { title:serviceById.energy.menuTitle, to:serviceById.energy.route },
  { title:"Kontakt", to:contactLink },
];

const routes = [
  { title:"O nás", path:"/", content:<LandingPage/> },
  ...serviceAreas.map(service=>({
    title:service.title,
    path:service.route,
    content:<ServicePage service={service} services={serviceAreas}/>
  })),
  { title:serviceById["it-nis2"].title, path:"/it", content:<ServicePage service={serviceById["it-nis2"]} services={serviceAreas}/> },
  { title:serviceById.logistics.title, path:"/logistic", content:<ServicePage service={serviceById.logistics} services={serviceAreas}/> },
];


export const Router = createRouter(routes);

tab.fit("title", (next, value)=>{
  const route = Router.matchRoute(page.get("pathname"));
  return jet.melt([route.title, info.title], " | ");
});

page.watch(_=>tab.set("title"));
